import { render, staticRenderFns } from "./EditKpis.vue?vue&type=template&id=e1aa917a&scoped=true&"
import script from "./EditKpis.vue?vue&type=script&lang=js&"
export * from "./EditKpis.vue?vue&type=script&lang=js&"
import style0 from "./EditKpis.vue?vue&type=style&index=0&id=e1aa917a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1aa917a",
  null
  
)

export default component.exports